<div class="container-screen-content">
  <app-network-snackbar></app-network-snackbar>

  <router-outlet></router-outlet>
</div>
